import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DipDipendente } from 'src/app/objects/DipDipendente';
import { UsrUser } from 'src/app/objects/UsrUser';
import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-edit-dipendenti',
  templateUrl: './edit-dipendenti.component.html',
  styleUrls: ['./edit-dipendenti.component.scss']
})
export class EditDipendentiComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditDipendentiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DipDipendente,
    private loadingService: LoadingService,
    private apiService: ApiService,
    private snackBarService: SnackbarService
    ) {
      console.log(data)
     }

  ngOnInit(): void {
  }

  saveData(){
    this.loadingService.showLoading();
    console.log(this.data)
    
    this.apiService.addOrEditDipendenti(this.data)
    .then(ret => {
      if(ret){
        this.snackBarService.openSnackBar("Operazione eseguita con successo.")
        this.dialogRef.close();
      } else {
        this.snackBarService.openSnackBar("Ops, qualcosa è andato storto, si prega di riprovare.")
      }
    }, err => {
      console.log(err);
    })
  }

  close(){
    this.dialogRef.close();
  }

}
